"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expandOrderItems = void 0;
const dayjs = require("dayjs");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const expandOrderItems = (items, include_extras = true) => {
    const newItems = [];
    items.forEach((item) => {
        if (!item.versions)
            return null;
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
        if (!latest_version)
            return null;
        if (item.type === "HOTEL") {
            if (latest_version.start_date !== latest_version.end_date) {
                const config = latest_version.config;
                const startDate = new Date(latest_version.start_date);
                const endDate = new Date(latest_version.end_date);
                const days = Math.round((endDate.getTime() - startDate.getTime()) / 86400000 + 1);
                for (let i = 0; i < days; i++) {
                    // is first
                    const first = i === 0;
                    const last = i === days - 1;
                    if (first) {
                        const linked_transfer_line = items.find((line) => {
                            if (!line.versions)
                                return false;
                            const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
                            if (!latest_version)
                                return false;
                            const tranfer_config = latest_version.config;
                            return (latest_version?.linked_line_id === item.id &&
                                tranfer_config.where_when_who.date ===
                                    dayjs(startDate).format("YYYY-MM-DD"));
                        });
                        if (linked_transfer_line &&
                            linked_transfer_line.versions &&
                            include_extras) {
                            const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(linked_transfer_line.versions);
                            // is the transfer either to or from the airport?
                            const transfer_config = latest_version?.config;
                            const airport_transfer = getAirportSummaryItem(dayjs(startDate).add(i, "day").format("YYYY-MM-DD"), 1, transfer_config);
                            if (airport_transfer) {
                                newItems.push({
                                    ...airport_transfer,
                                    region_id: latest_version?.region_id,
                                    region: latest_version?.regions,
                                });
                            }
                            newItems.push({
                                ...linked_transfer_line,
                                region_id: latest_version?.region_id,
                                region: latest_version?.regions,
                                order_weight: 1,
                            });
                        }
                        newItems.push({
                            ...item,
                            region_id: latest_version?.region_id,
                            region: latest_version?.regions,
                            order_weight: 1,
                        });
                    }
                    if (!first && include_extras) {
                        const newItem = {};
                        newItem.start_date = dayjs(startDate)
                            .add(i, "day")
                            .format("YYYY-MM-DD");
                        newItem.end_date = dayjs(startDate)
                            .add(i, "day")
                            .format("YYYY-MM-DD");
                        newItem.type = item.type;
                        newItem.order_weight = last ? 1 : 10;
                        newItem.title = last
                            ? `Check-out from ${config.where_when_who.hotel?.name?.en} (by ${config.where_when_who.hotel.check_out_time})`
                            : `Overnight at ${config.where_when_who.hotel?.name?.en} (Night ${i + 1} of ${days - 1}) `;
                        newItems.push({
                            ...newItem,
                            region_id: latest_version?.region_id,
                            region: latest_version?.regions,
                        });
                    }
                    if (last && include_extras) {
                        const linked_transfer_line = items.find((line) => {
                            if (!line.versions)
                                return false;
                            const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
                            if (!latest_version)
                                return false;
                            const tranfer_config = latest_version.config;
                            return (latest_version?.linked_line_id === item.id &&
                                tranfer_config.where_when_who.date ===
                                    dayjs(startDate).add(i, "day").format("YYYY-MM-DD"));
                        });
                        if (linked_transfer_line && linked_transfer_line.versions) {
                            const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(linked_transfer_line.versions);
                            newItems.push({
                                ...linked_transfer_line,
                                region_id: latest_version?.region_id,
                                region: latest_version?.regions,
                                order_weight: 11,
                            });
                            const transfer_config = latest_version?.config;
                            const airport_transfer = getAirportSummaryItem(dayjs(startDate).add(i, "day").format("YYYY-MM-DD"), 12, transfer_config);
                            if (airport_transfer) {
                                newItems.push({
                                    ...airport_transfer,
                                    region_id: latest_version?.region_id,
                                    region: latest_version?.regions,
                                });
                            }
                        }
                    }
                }
            }
        }
        else if (item.type === "GOLF") {
            // is there a linked transfer line for this golf line?
            // for the current item.id get the latest version and check if there is a linked_line_id
            // if there is a linked_line_id then get the linked line and add it to the itinerary
            const linked_transfer_line = items.find((line) => {
                if (!line.versions)
                    return false;
                const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
                if (!latest_version)
                    return false;
                return latest_version?.linked_line_id === item.id;
            });
            if (linked_transfer_line &&
                linked_transfer_line.versions &&
                include_extras) {
                const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(linked_transfer_line.versions);
                newItems.push({
                    ...linked_transfer_line,
                    region_id: latest_version?.region_id,
                    region: latest_version?.regions,
                    order_weight: 1,
                });
            }
            newItems.push({
                ...item,
                region_id: latest_version?.region_id,
                region: latest_version?.regions,
                order_weight: 1,
            });
            if (linked_transfer_line && include_extras) {
                if (!linked_transfer_line.versions)
                    return;
                const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(linked_transfer_line.versions);
                if (!latest_version)
                    return;
                const config = latest_version.config;
                if (config.where_when_who.type !== "ONE_WAY") {
                    newItems.push({
                        title: config.where_when_who.type === "RETURN"
                            ? `Return journey to ${config?.transfer_legs?.inbound?.to_name}`
                            : `Onward journey to ${config?.transfer_legs?.inbound?.to_name}`,
                        start_date: latest_version.start_date,
                        status: latest_version.status,
                        supplier_id: config?.supplier?.id,
                        region_id: latest_version.region_id,
                        region: latest_version?.regions,
                        type: "TRANSFER",
                        end_date: latest_version.end_date,
                        order_weight: 1,
                    });
                }
            }
        }
        else if (item.type === "TRANSFER") {
            // if the transfer is linked to another line then hide it.
            // const config = latest_version.config as TransferOrderLine;
            // const airport_transfer = getAirportSummaryItem(
            //   dayjs(config?.where_when_who?.date).format("YYYY-MM-DD"),
            //   12,
            //   config
            // );
            // const airport_data = getAirportTransferData(config);
            // if (airport_transfer && airport_data?.inbound) {
            //   newItems.push({
            //     ...airport_transfer,
            //     order_weight: 1,
            //     region_id: latest_version?.region_id,
            //     region: latest_version?.regions,
            //   });
            // }
            if (latest_version.linked_line_id === null && include_extras) {
                newItems.push({
                    ...item,
                    region_id: latest_version?.region_id,
                    region: latest_version?.regions,
                    order_weight: 1,
                });
            }
            if (!include_extras) {
                newItems.push({
                    ...item,
                    region_id: latest_version?.region_id,
                    region: latest_version?.regions,
                    order_weight: 1,
                });
            }
            // if (airport_transfer && airport_data?.outbound) {
            //   newItems.push({
            //     ...airport_transfer,
            //     order_weight: 1,
            //     region_id: latest_version?.region_id,
            //     region: latest_version?.regions,
            //   });
            // }
        }
        else if (item.type === "EXCURSION") {
            // if the transfer is linked to another line then hide it.
            const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
            if (!latest_version)
                return null;
            newItems.push({
                ...item,
                region_id: latest_version?.region_id,
                region: latest_version?.regions,
                order_weight: 1,
            });
        }
        else if (item.type === "CUSTOM") {
            newItems.push({
                ...item,
                region_id: latest_version?.region_id,
                region: latest_version?.regions,
                order_weight: 1,
            });
        }
    });
    return newItems;
};
exports.expandOrderItems = expandOrderItems;
const getAirportSummaryItem = (date, weight, transfer_config) => {
    const airport_transfer = getAirportTransferData(transfer_config);
    if (airport_transfer) {
        const arrival_data = transfer_config?.transfer_legs?.outbound
            .from_details;
        const departure_data = transfer_config?.transfer_legs?.outbound
            .to_details;
        const newItem = {};
        newItem.start_date = dayjs(date).format("YYYY-MM-DD");
        newItem.end_date = dayjs(date).format("YYYY-MM-DD");
        newItem.type = "FLIGHT";
        newItem.order_weight = weight;
        newItem.title = airport_transfer.inbound
            ? `Arrival at  ${transfer_config?.transfer_legs?.outbound?.from_name} ${arrival_data?.flight_number
                ? `(${arrival_data?.flight_number} ${arrival_data?.flight_time && `/ ${arrival_data?.flight_time}`})`
                : "(Flight info TBC)"}`
            : `Departure from ${transfer_config?.transfer_legs?.outbound?.to_name} ${departure_data?.flight_number
                ? `(${departure_data?.flight_number} ${departure_data?.flight_time &&
                    `/ ${departure_data?.flight_time}`})`
                : "(Flight info TBC)"}`;
        return newItem;
    }
    return null;
};
const getAirportTransferData = (config) => {
    const is_airport_transfer = config.transfer_legs.outbound.from_type === "Airport" ||
        config.transfer_legs.outbound.to_type === "Airport" ||
        config.transfer_legs.inbound.from_type === "Airport" ||
        config.transfer_legs.inbound.to_type === "Airport";
    const is_inbound_airport_transfer = config.transfer_legs.outbound.from_type === "Airport";
    const is_outbound_airport_transfer = config.transfer_legs.inbound.to_type === "Airport";
    if (!is_airport_transfer)
        return null;
    return {
        inbound: is_inbound_airport_transfer,
        outbound: is_outbound_airport_transfer,
    };
};
